import CheckIcon from '@material-ui/icons/Check';
import React from 'react';

const CaseStatusTrackerItem = ({ isComplete, isCurrent, title, label, showPhaseLabel, dueDate }) => {
  let className = 'future';
  let indicatorClassName = 'future-circle';
  let phaseText = 'Next phase';

  if (isComplete) {
    className = 'complete';
    indicatorClassName = 'completed-circle';
    phaseText = 'Completed';
  }

  if (isCurrent) {
    className = 'in-progress';
    indicatorClassName = 'in-progress-circle';
    phaseText = 'Current phase';
  }

  return (
    <li className={className} aria-label={label}>
      <div className={indicatorClassName}>{isComplete && <CheckIcon />}</div>
      <p>
        {title}
        {showPhaseLabel && <span className="phase-label">{phaseText}</span>}
      </p>
    </li>
  );
};

export default CaseStatusTrackerItem;
